module.exports = __webpack_public_path__ + "img/mclogi-desktop@2x.489ebc4.png";